module.exports = __webpack_public_path__ + "static/media/mock-up.6a9c27cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/emptyState/mock-up.png
// module id = 28
// module chunks = 0